import { API } from "./../../../api/config";

export const getWSPartnersAPI = (params) => {
    return API.get("/pmbpartner/ws-partners", { params })
              .then((res) => res);
};

export const createWSPartnersAPI = (payload) => {
    return API.post(`/pmbpartner/ws-partners`, payload)
              .then((res) => res);
};

export const updateWSPartnersAPI = (param) => {
    return API.patch(`/pmbpartner/ws-partners/update`, param?.payload)
              .then((res) => res);
};

export const getCnpjAPI = (params) => {
    return API.get("/pmbpartner/ws-partners/get-cnpj", { params })
              .then((res) => res);
};